export default __webpack_public_path__ + "static/media/closeConversation.c6ca2be5.mp3";